import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';

import { BaseFormComponent } from './base-form.component';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<BaseFormComponent> {
	canDeactivate(component: BaseFormComponent): boolean {
		if (!component.canDeactivate()) {
			if (
				confirm(
					'Existem alterações não salvas. Deseja confirmar a saída?'
				)
			) {
				return true;
			} else {
				return false;
			}
		}
		return true;
	}
}
